import React, { useEffect } from "react";
import "../process-orders/styles.css";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import TopBarProgress from "react-topbar-progress-indicator";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { RiErrorWarningFill } from "react-icons/ri";
import { ImAttachment } from "react-icons/im";
import { CircularProgress, Pagination } from "@mui/material";
import moment from "moment";
import { getAllPendingOrders } from "../../../../actions/order";
import EditTabelDrawer from "../../../../components/Edit-tabel-drawer/EditTabelDrawer";
import OrderDetails from "../components/OrderDetails";
import UpdateOrderComp from "../components/UpdateOrderComp";
import SearchFilter from "../../../../components/CustomeFilter/SearchFilter";
import SelectSearchFilter from "../../../../components/CustomeFilter/SelectSearchFilter";
import AddNewNotes from "../components/AddNewNotes";
import ShowNotes from "../components/ShowNotes";
import OrderStatusButton from "../components/OrderStatusButton";

import { Calculation } from "../../../../utils/Calculation";
import ShippingUpdateComp from "../components/ShippingUpdateComp";
import { getAllCompany } from "../../../../actions/shipping";
import CostBreakDown from "../sale-analysis/components/CostBreakDown";
import CostsUpdateComp from "../sale-analysis/components/CostsUpdateComp";
import DashboardPagesLayout from "../../customerServiceDashboard/components/DashboardPagesLayout";
import DateRangeFilter from "../../../../components/CustomeFilter/DateRangeFilter";
import { MMDDYYFormat } from "../../../../utils/dateFormate";
import {
  getCompanyName,
  getEditCostBodyContent,
  getEditCostStatus,
  getPendinOrdersShippingType,
} from "./utils";
import { fetchAllStores } from "../../../../reducers/storesSlice";

const PendingOrders = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderNumber = searchParams.get("orderNumber");

  // Local State
  const [loading, setloading] = useState(true);
  const [InnderLoader, setInnderLoader] = useState(false);
  const [ShippingComapny, setShippingComapny] = useState([]);

  const [SelectItem, setSelectItem] = useState({});
  const [AllOrders, setAllOrders] = useState([]);

  const initialSearchFilter = {
    OrderStatus: "pending",
    TrackingDetails: "",
    SearchByDate: "",
    SearchQuery: orderNumber ?? "",
    sort: "",
    claims: "",
    refunds: "",
    deliverytype: "",
    brand: "",
    shipandtrack: "",
    trackingStatus: "",
  };
  // eslint-disable-next-line no-unused-vars
  const [Brand, setBrand] = useState(JSON.parse(localStorage.getItem("Brand")));
  const [SearchFillter, setSearchFillter] = useState(initialSearchFilter);
  const [IsMount, setIsMount] = useState(false);

  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });

  const resetFilters = () => {
    setSearchFillter(initialSearchFilter);
    resetToFirstPage();
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate({
      pathname: location.pathname,
      search: `?${createSearchParams({ page: 1 })}`,
    }, { replace: true });
  };

  const setDateToEmpty = (inputDate) => {
    return inputDate === "mm/dd/yy,mm/dd/yy" ? "" : inputDate;
  };

  // Api calls for get Order
  const getOrders = useCallback(
    async (
      pageNumber,
      searchQuery,
      status,
      date,
      tracking,
      sort,
      claims,
      deliverytype,
      pickupDate,
      deliveryDate,
      deliveryEndDate,
      brand,
      trackingStatus,
      shipandtrack
    ) => {
      setInnderLoader(true);
      try {
        date = setDateToEmpty(date);
        const res = await dispatch(
          getAllPendingOrders(
            pageNumber,
            searchQuery,
            status,
            date,
            tracking,
            sort,
            claims,
            deliverytype,
            pickupDate,
            deliveryDate,
            deliveryEndDate,
            brand,
            shipandtrack,
            trackingStatus
          )
        );
        if (res) {
          // set to Seleted item when update because we set new Seleted item
          const newSelected =
            res?.orders?.find((order) => order._id === SelectItem._id) ?? {};
          setSelectItem(newSelected);
          setAllOrders(res?.orders);
          setpagination({
            ...res.pagination,
          });
        }
      } catch (error) {
        // console.log("error code is : ", error);
      } finally {
        setloading(false);
        setInnderLoader(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [AllOrders, SelectItem]
  );

  const getAllComapnyList = useCallback(async () => {
    const res = await dispatch(getAllCompany());
    if (res) {
      setShippingComapny(res);
    }
  }, [dispatch]);

  // company list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination((prev) => ({ ...prev, currentPage: page }));
    }
    getAllComapnyList();
  }, [location.search, getAllComapnyList]);

  useEffect(() => {

    // setInnderLoader(true);
    // setloading(true);
    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getOrders(
          pagination.currentPage,
          SearchFillter.SearchQuery,
          SearchFillter.OrderStatus,
          SearchFillter.SearchByDate,
          "",
          SearchFillter.sort,
          SearchFillter.claims,
          SearchFillter.deliverytype,
          "",
          "",
          SearchFillter.TrackingDetails,
          SearchFillter.brand,
          SearchFillter.shipandtrack
        );
        getAllComapnyList();
        if (Brand) {
          dispatch(fetchAllStores());
        }

      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.currentPage,
    SearchFillter.SearchQuery,
    SearchFillter.OrderStatus,
    SearchFillter.SearchByDate,
    SearchFillter.TrackingDetails,
    SearchFillter.sort,
    SearchFillter.claims,
    SearchFillter.refunds,
    SearchFillter.brand,
    SearchFillter.deliverytype,
    SearchFillter.shipandtrack,
    IsMount,
    Edit.open,
  ]);

  // handle page change query
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const handleAction = (item, actionType) => {
    const editConfig = {
      orderStatus: { edit: "orderStatus", title: "Order Status" },
      Notes: { edit: "Notes", title: "Notes" },
      shipping: { edit: "shipping", title: "Shipping & Tracking" },
      editCosts: { edit: "editCosts", title: "Edit Costs" },
    };
    const config = editConfig[actionType];

    if (config) {
      setEdit({
        open: true,
        edit: config.edit,
        title: config.title,
      });
      setSelectItem({ ...item });
    }
  };

  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className=" d-flex  justify-content-end align-center flex-wrap gap-10">
            <SearchFilter
              width={"250px"}
              type="text"
              placeholder={"Search Order #, Tracking #"}
              value={SearchFillter?.SearchQuery}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchQuery: e.target.value,
                });
              }}
            />

            <DateRangeFilter
              title={"Order Date"}
              placeholder={"Select"}
              value={SearchFillter?.SearchByDate}
              startDate={SearchFillter?.SearchByDate.split(",")[0]}
              endDate={SearchFillter?.SearchByDate.split(",")[1]}
              onChange={(Date) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchByDate: `${MMDDYYFormat(Date[0])},${MMDDYYFormat(
                    Date[1]
                  )}`,
                });
              }}
            />

            <SelectSearchFilter
              title={"Brand"}
              placeholder="Select"
              width={"200px"}
              value={
                SearchFillter?.brand
                  ? Brand.find((item) => SearchFillter?.brand === item?.id)
                    .value
                  : ""
              }
              options={Brand}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  brand:
                    value !== ""
                      ? Brand.find((item) => item.value === value)?.id
                      : "",
                });
              }}
            />
            <SelectSearchFilter
              title={"Delivery Type"}
              placeholder="Select"
              value={SearchFillter?.deliverytype}
              options={[
                { value: "standard", label: "Standard" },
                { value: "bronze", label: "Bronze" },
                { value: "silver", label: "Silver" },
                { value: "gold", label: "Gold" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, deliverytype: value });
              }}
            />
            <SelectSearchFilter
              title={"Shipping & Tracking"}
              placeholder="Select"
              value={SearchFillter?.shipandtrack}
              options={[
                { value: "notProvided", label: "+Add" },
                { value: "provided", label: "included" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, shipandtrack: value });
              }}
            />

            <SelectSearchFilter
              title={"Claim"}
              placeholder="Select"
              value={SearchFillter?.claims}
              options={[
                { value: "", label: "+Add" },
                { value: "Cancel", label: "Pending" },
                { value: "Accept", label: "Accepted" },
                { value: "Reject", label: "Rejected" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, claims: value });
              }}
            />

            <SelectSearchFilter
              title={"Sort"}
              placeholder="Select"
              value={SearchFillter?.sort}
              options={[
                { value: "desc", label: "Newest First" },
                { value: "asc", label: "Oldest First" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, sort: value });
              }}
            />
            <button
              onClick={resetFilters}
              className="reset-filter-button search-filter "
            >
              Reset Filters
            </button>
          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Pending Orders"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="process-orders-table">
                <table className="m-0">
                  <thead>
                    <tr>
                      <th>Order#</th>
                      <th>Order Date</th>
                      <th>Order Status</th>
                      <th>Brand</th>
                      <th>Qty</th>
                      <th style={{ padding: "0 5px" }}>Stocks</th>

                      <th>
                        Shipping &<br /> Tracking
                      </th>
                      <th>
                        Ship
                        <br /> Type
                      </th>
                      <th>Carrier</th>
                      <th>
                        Order
                        <br /> Total
                      </th>

                      <th>Profit</th>
                      <th>COGS</th>
                      <th>CC</th>
                      <th>Tax</th>
                      <th>
                        Priority <br /> Protection
                      </th>
                      <th>
                        Cashback <br /> Used
                      </th>

                      <th>
                        Ship
                        <br /> Cost
                      </th>
                      <th>
                        DS <br /> Fees
                      </th>
                      <th>
                        Shipping
                        <br /> Party
                      </th>

                      <th>Margin</th>
                      <th>Fraud</th>
                      <th>Edit Costs</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {AllOrders?.length ? (
                      <>
                        {AllOrders?.map((order) => (
                          <tr key={order?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${order?._id}`)
                              }
                            >
                              {order?.itemOrderNumber}
                            </td>
                            <td>{moment(order?.createdAt).format("L")}</td>
                            <td>
                              <span
                                onClick={() => {
                                  order?.backorderStatus?.status !== "cancel" &&
                                    handleAction(order, "orderStatus");
                                }}
                              >
                                <OrderStatusButton
                                  width={250}
                                  status={order.status}
                                >
                                  {order.status}{" "}
                                  {order.status === "Backordered"
                                    ? `(${order?.backorderStatus?.status
                                      ? order?.backorderStatus?.status
                                      : "Pending"
                                    })`
                                    : null}
                                </OrderStatusButton>
                              </span>
                            </td>
                            <td>{order?.brandId?.fullName.split(" ")[0] || order?.manufacturer} </td>
                            <td>{order?.quantity}</td>
                            <td style={{ color: order?.productId?.quantity < 6 ? 'red' : 'inherit', fontWeight: order?.productId?.quantity < 6 ? 'bold' : 'normal' }}>
                              {order?.productId?.quantity}
                            </td>
                            <td>
                              <span
                                onClick={() => {
                                  order?.status !== "Backordered" &&
                                    handleAction(order, "shipping");
                                }}
                              >
                                <OrderStatusButton
                                  width={140}
                                  status={
                                    order?.shippingInfo?.labels.length &&
                                      order?.shippingInfo?.labels?.[0].default
                                      ? "Processing"
                                      : "In Transit"
                                  }
                                >
                                  {order?.shippingInfo?.labels.length &&
                                    order?.shippingInfo?.labels?.[0].default
                                    ? "Included"
                                    : "+Add"}
                                </OrderStatusButton>
                              </span>
                            </td>
                            <td>
                              <span
                                style={
                                  order?.orShipping?.type === "WG" ||
                                    order?.shipType === "WG"
                                    ? {}
                                    : { color: "#878787" }
                                }
                              >
                                {getPendinOrdersShippingType(order)}
                              </span>
                            </td>
                            <td>{getCompanyName(order)}</td>
                            <td>${Calculation(order, "OrderTotal")}</td>

                            <td>${Calculation(order, "profit")} </td>

                            <td
                              style={
                                order?.orCogs?.type === "promo"
                                  ? { color: "#17a858" }
                                  : order?.costType === "promo"
                                    ? { color: "#17a858" }
                                    : {}
                              }
                            >
                              ${Calculation(order, "COGS")}{" "}
                            </td>
                            <td>${Calculation(order, "CC")} </td>
                            <td>${Calculation(order, "Tax")} </td>
                            <td>${order?.shippingProtectionFee?.toFixed(2)}</td>
                            <td>${order?.cashbackUsedPerItem}</td>

                            <td>${Calculation(order, "shippingTotal")}</td>
                            <td>${Calculation(order, "dsFee")}</td>
                            <td>
                              {order.isSundialShipping
                                ? "Sundial"
                                : order?.brandId?.fullName.split(" ")[0]}
                            </td>
                            <td>{Calculation(order, "profitPercentage")}%</td>
                            {/* {console.log("order", (order?._id === "680b9d6b97df0961f2e0fc3d" && order?.orderID?.warnings?.length) && order)} */}
                            <td>
                              {order?.orderID?.warnings?.length ? (
                                <>
                                  {!order.fraudVerify || order.fraudVerify === "required" ? (
                                    <div className={"d-flex gap-5"}>
                                      <button
                                        className={"fraud-active-btn"}
                                        style={{ width: "60px", height: "60px", borderRadius: "8px" }}
                                      >
                                        <RiErrorWarningFill
                                          style={{
                                            fontSize: "26px",
                                            color: "#fb2a3d",
                                          }}
                                        />

                                      </button>
                                      <div
                                        style={{
                                          backgroundColor: "#ffb404",
                                          color: "white",
                                          width: "60px",
                                          height: "60px",
                                          borderRadius: "8px",
                                          textAlign: "center",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          lineHeight: "1.1",
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <div style={{ fontSize: "16px" }}>FC</div>
                                        <div>Required</div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="d-flex justify-content-start align-items-center">
                                      {(() => {
                                        // const status = "passed";
                                        const status = order?.fraudVerify || order?.orderID?.fraudStatus;
                                        // console.log("status", status)
                                        const statusMap = {
                                          passed: { labelTop: "FC", labelBottom: "Passed", bg: "#17a858" },
                                          failed: { labelTop: "FC", labelBottom: "Failed", bg: "#fb2a3d" },
                                          sent: { labelTop: "FC", labelBottom: "Sent", bg: "#0572bd" },
                                        };

                                        const current = statusMap[status];
                                        // console.log("current", current)
                                        if (!current) return null;

                                        return (
                                          <div
                                            style={{
                                              backgroundColor: current.bg,
                                              color: "white",
                                              width: "60px",
                                              height: "60px",
                                              borderRadius: "8px",
                                              textAlign: "center",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              lineHeight: "1.1",
                                              fontWeight: "bold",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <div style={{ fontSize: "16px" }}>{current.labelTop}</div>
                                            <div>{current.labelBottom}</div>
                                          </div>
                                        );
                                      })()}
                                    </div>
                                  )}

                                </>
                              ) : (
                                // <div className="d-flex justify-content-start align-items-center">
                                //   {(() => {
                                //     // const status = "passed";
                                //     const status = order?.fraudVerify || order?.orderID?.fraudStatus;

                                //     const statusMap = {
                                //       passed: { labelTop: "FC", labelBottom: "Passed", bg: "#17a858" },  
                                //       failed: { labelTop: "FC", labelBottom: "Failed", bg: "#fb2a3d" },  
                                //       sent: { labelTop: "FC", labelBottom: "Sent", bg: "#0572bd" },     
                                //     };

                                //     const current = statusMap[status];

                                //     if (!current) return null;

                                //     return (
                                //       <div
                                //         style={{
                                //           backgroundColor: current.bg,
                                //           color: "white",
                                //           width: "60px",
                                //           height: "60px",
                                //           borderRadius: "8px",
                                //           textAlign: "center",
                                //           display: "flex",
                                //           flexDirection: "column",
                                //           justifyContent: "center",
                                //           lineHeight: "1.1",
                                //           fontWeight: "bold",
                                //           fontSize: "12px",
                                //         }}
                                //       >
                                //         <div style={{fontSize:"16px"}}>{current.labelTop}</div>
                                //         <div>{current.labelBottom}</div>
                                //       </div>
                                //     );
                                //   })()}
                                // </div>
                                <></>
                              )}
                            </td>
                            <td>
                              {/* Edit Button  */}
                              <div
                                onClick={() => {
                                  order?.backorderStatus?.status !== "cancel" &&
                                    handleAction(order, "editCosts");
                                }}
                              >
                                <OrderStatusButton
                                  width={130}
                                  status={getEditCostStatus(order)}
                                >
                                  {getEditCostBodyContent(order)}
                                </OrderStatusButton>
                              </div>
                            </td>
                            <td>
                              <div onClick={() => handleAction(order, "Notes")}>
                                <OrderStatusButton
                                  width={90}
                                  status={
                                    order?.notes?.length ? "In Transit" : "+add"
                                  }
                                >
                                  <span>
                                    <ImAttachment
                                      style={{
                                        fontSize: "20px",
                                      }}
                                    />
                                  </span>
                                  <span className="ml-2">
                                    {order?.notes?.length}
                                  </span>
                                </OrderStatusButton>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={19} className=" text-center">
                            {" "}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <EditTabelDrawer
                  Edit={Edit}
                  setEdit={setEdit}
                  shippingId={SelectItem?.itemOrderNumber}
                >
                  {InnderLoader ? (
                    <div className=" d-flex align-center justify-content-center">
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {/* Error Line code */}
                      {Edit.edit === "editCosts" && (
                        <>
                          <CostsUpdateComp
                            SelectItem={SelectItem}
                            IsMount={IsMount}
                            setIsMount={setIsMount}
                          />
                          <CostBreakDown SelectItem={SelectItem} />
                          <ShowNotes
                            title="Cost Notes"
                            notes={SelectItem?.notes?.filter(
                              (message) => message.subject === "Costs"
                            )}
                          />
                        </>
                      )}
                      {Edit.edit === "orderStatus" && (
                        <>
                          <UpdateOrderComp
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                          />
                          <hr />
                          <ShowNotes
                            title="Order Status Notes"
                            SelectItem={SelectItem}
                            notes={SelectItem?.notes?.filter(
                              (message) => message.subject === "Order Status"
                            )}
                          />
                          <hr />
                          <AddNewNotes
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                            setAllOrders={setAllOrders}
                          />
                        </>
                      )}
                      {Edit.edit === "shipping" && (
                        <>
                          <ShippingUpdateComp
                            page="pending"
                            setIsMount={setIsMount}
                            IsMount={IsMount}
                            SelectItem={SelectItem}
                            ShippingComapny={ShippingComapny}
                            CurrentStatus={initialSearchFilter.OrderStatus}
                          />
                          <hr />
                          <ShowNotes
                            title="Shipping & Tracking Notes"
                            SelectItem={SelectItem}
                            notes={SelectItem?.notes?.filter(
                              (message) =>
                                message.subject === "Shipping & Tracking"
                            )}
                          />
                          <hr />
                          <AddNewNotes
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                            setAllOrders={setAllOrders}
                          />
                        </>
                      )}
                      {Edit.edit === "Notes" && (
                        <>
                          <AddNewNotes
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                            setAllOrders={setAllOrders}
                          />
                          <ShowNotes
                            title="All Notes"
                            SelectItem={SelectItem}
                            notes={SelectItem?.notes}
                          />
                        </>
                      )}

                      <OrderDetails
                        IsMount={IsMount}
                        setIsMount={setIsMount}
                        setEdit={setEdit}
                        SelectItem={SelectItem}
                      />
                    </>
                  )}
                </EditTabelDrawer>
              </div>
              <div className="d-flex justify-content-center align-center p-2">
                <div className="mx-auto">
                  <Pagination
                    count={pagination.totalPages}
                    page={pagination.currentPage}
                    onChange={handleChange}
                  />
                </div>

                <span className="font-weight-bold" style={{ color: "#9f9f9f" }}>
                  {AllOrders?.length} of {pagination?.count} Items
                </span>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default PendingOrders;
